/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Natural person who signs the SEPA mandate and receives the signature code — the debtor when they are a natural person, otherwise a representative (manager) of the legal entity.
 * @export
 * @interface MandateSignatoryDto
 */
export interface MandateSignatoryDto {
    /**
     * 
     * @type {string}
     * @memberof MandateSignatoryDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MandateSignatoryDto
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof MandateSignatoryDto
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MandateSignatoryDto
     */
    email?: string | null;
    /**
     * Désignation du débiteur pour lequel le signataire signe (souscripteur, ou cabinet du courtier encaisseur)
     * @type {string}
     * @memberof MandateSignatoryDto
     */
    debtorName?: string;
    /**
     * True when the signatory is the debtor themself (natural person).
     * @type {boolean}
     * @memberof MandateSignatoryDto
     */
    isDebtor: boolean;
    /**
     * True when the signature request can be sent — email known. The mobile is checked and confirmed in the sending panel, which sends it back.
     * @type {boolean}
     * @memberof MandateSignatoryDto
     */
    canSign: boolean;
    /**
     * The signatory is the connected user (the firm's manager when the firm pays) — the panel lets them fill their own mobile instead of blocking.
     * @type {boolean}
     * @memberof MandateSignatoryDto
     */
    isCurrentUser?: boolean;
}

/**
 * Check if a given object implements the MandateSignatoryDto interface.
 */
export function instanceOfMandateSignatoryDto(value: object): value is MandateSignatoryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('isDebtor' in value) || value['isDebtor'] === undefined) return false;
    if (!('canSign' in value) || value['canSign'] === undefined) return false;
    return true;
}

export function MandateSignatoryDtoFromJSON(json: any): MandateSignatoryDto {
    return MandateSignatoryDtoFromJSONTyped(json, false);
}

export function MandateSignatoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MandateSignatoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullName': json['fullName'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'debtorName': json['debtorName'] == null ? undefined : json['debtorName'],
        'isDebtor': json['isDebtor'],
        'canSign': json['canSign'],
        'isCurrentUser': json['isCurrentUser'] == null ? undefined : json['isCurrentUser'],
    };
}

export function MandateSignatoryDtoToJSON(json: any): MandateSignatoryDto {
    return MandateSignatoryDtoToJSONTyped(json, false);
}

export function MandateSignatoryDtoToJSONTyped(value?: MandateSignatoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fullName': value['fullName'],
        'phone': value['phone'],
        'email': value['email'],
        'debtorName': value['debtorName'],
        'isDebtor': value['isDebtor'],
        'canSign': value['canSign'],
        'isCurrentUser': value['isCurrentUser'],
    };
}

